import { PaymentMethodTypeEnum } from "../../../types/entities/payment";

export const typesWithoutRegularLimit: PaymentMethodTypeEnum[] = [PaymentMethodTypeEnum.BALANCE, PaymentMethodTypeEnum.CASH, PaymentMethodTypeEnum.OTHER];
